import { Reactive, ReactRouterConfig } from '@scfe-common/micro-frontend-utils';

import { $gt } from '../../common/appCtx';
import WorkstationActivityType from './activity-type/index';
import BatchLog from './batch-log/index';
import BatchOperation from './batch-operation/index';

const config: ReactRouterConfig = {
  path: '/workstation',
  component: () => Reactive,
  meta: {
    title: $gt('Workstation'),
  },
  children: [
    {
      path: '/batch-operation',
      component: () => BatchOperation,
      meta: {
        title: $gt('Workstation Batch Opeation'),
      },
    },
    {
      path: '/batch-log',
      component: () => BatchLog,
      meta: {
        title: $gt('Workstation Batch Log'),
      },
    },
    {
      path: '/activity-type',
      component: () => WorkstationActivityType,
      meta: {
        title: $gt('Workstation Batch Log'),
      },
    },
  ],
};

export default config;
